import React from 'react';
import { format } from 'date-fns';
import common from 'constants/common';

import type { INewPatientsData } from 'infrastructure/interfaces/';

interface IProps {
  data: INewPatientsData;
}

const ActiveDateColumn: React.FC<IProps> = ({ data }) => {
  return (
    <div>{format(new Date(data.activeDate), common.dateFormats.full)}</div>
  );
};

export default ActiveDateColumn;
